import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { filtrarContextos, possuiFormulasContexto } from '@shared/components/formula/utils/formula-contexto.util';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormulaCatalogoGrupoStruct } from '../../../../../../shared/services/structs/formula/formula-catalogo-grupo.struct';
import { AlertCardComponent } from '../../../../../../shared/components/alert-card/alert-card.component';
import { EmptyListComponent } from '../../../../../../shared/components/empty-list/empty-list.component';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { LoadingBoxComponent } from '../../../../../../shared/components/loading-box/loading-box.component';
import { FormulaGrupoComponent } from '@shared/components/formula/formula-grupo/formula-grupo.component';
import { TabsScrollDirective } from '../../../../../../shared/directives/tabs-scroll.directive';

@Component({
    selector: 'app-formulas-tab',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatTabsModule,
        TabsScrollDirective,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        AlertCardComponent,
        LoadingBoxComponent,
        EmptyListComponent,
        EmptyStateComponent,
        FormulaGrupoComponent,
    ],
    templateUrl: './formulas-lista.component.html',
    styleUrl: './formulas-lista.component.css',
})
export class FormulasTabComponent implements OnChanges {
    @Input() grupos: FormulaCatalogoGrupoStruct[] = [];
    @Input() isLoading: boolean = false;
    @Output() modeloEmpresaSelecionado = new EventEmitter<{ chaveFormula: string; chaveFormulaModelo: string }>();

    public pesquisa: string = '';
    public gruposFiltrados: FormulaCatalogoGrupoStruct[] = [];

    ngOnChanges(): void {
        this.filtrar();
    }

    public iconeGrupo(grupo: FormulaCatalogoGrupoStruct): string {
        return grupo.googleIconClass || 'calculate';
    }

    public possuiFormulas(grupo: FormulaCatalogoGrupoStruct): boolean {
        return possuiFormulasContexto(grupo);
    }

    public filtrar(): void {
        const termo = (this.pesquisa || '').trim().toLowerCase();
        if (!termo) {
            this.gruposFiltrados = this.grupos;
            return;
        }
        this.gruposFiltrados = filtrarContextos(this.grupos, termo);
    }

    public limparPesquisa(): void {
        this.pesquisa = '';
        this.filtrar();
    }

}
